import React from "react";

import { AuthProvider } from "./auth";
import { RefreshProvider } from "./refresh";
import { Props } from "../global/types";

const AppProvider: React.FC<Props> = ({ children }) => {
  return (
    <AuthProvider>
      <RefreshProvider>{children}</RefreshProvider>
    </AuthProvider>
  );
};

export default AppProvider;
